import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

export const reportDescriptionExpandedEvent = (type = {}) => {
    tracker.sendBQEvent(
        getBQClickFields({
            type: type.BigQuery,
            elementName: 'reviews',
            componentName: 'reviews',
        })
    );
};

export const Events = {
    seeMore: {
        BigQuery: 'clicked_on_see_more_text',
    },
    seeLess: {
        BigQuery: 'clicked_on_see_less_text',
    },
};
